
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {FuseSidebarModule} from "../../../@fuse/components";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {TranslateModule} from "@ngx-translate/core";
import {EmployeeScheduleComponent} from "./employeeSchedule.component";
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import {WeekViewSchedulerComponent} from "./week-view-scheduler.component";
import {EmployeeScheduleDialogComponent} from "./dialog/employeeScheduleDialog.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import { DatePipe } from '@angular/common'
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {DeleteEmployeeScheduleDialogComponent} from "./dialog/deleteEmployeeScheduleDialog.component";
import {SelectedEmpoyeeScheduleComponent} from "./selectedEmpoyeeSchedule/selectedEmpoyeeSchedule.component";

@NgModule({
    declarations: [
        EmployeeScheduleComponent,
        WeekViewSchedulerComponent,
        EmployeeScheduleDialogComponent,
        DeleteEmployeeScheduleDialogComponent,
        SelectedEmpoyeeScheduleComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,
        MatCheckboxModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,

        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        MatToolbarModule,
        MatDialogModule,
        MatButtonToggleModule,

    ],
    providers: [
        DatePipe
    ],
    bootstrap: [
        EmployeeScheduleComponent,
        EmployeeScheduleDialogComponent,
        DeleteEmployeeScheduleDialogComponent,
        SelectedEmpoyeeScheduleComponent,
    ]
})
export class EmployeeScheduleModule { }
